import packageJson from '@/package.json'

export function clampSampleRate(raw: unknown): number {
    const parsed = Number(raw)

    if (!Number.isFinite(parsed)) return 0
    if (parsed < 0) return 0
    if (parsed > 1) return 1

    return parsed
}

export const RUM_RELEASE = `toad@${packageJson.version}`

/** Bumped whenever the payload shape changes, so the collector can branch. */
export const RUM_PAYLOAD_VERSION = 1

/** Selectors can be arbitrarily long; keep the payload bounded. */
export const RUM_MAX_SELECTOR_LENGTH = 120
